/**
 * api.js — 统一的 API 地址定义（A-02）
 *
 * 所有前端文件统一引用此模块：
 *   import { API_BASE, API } from './api';
 *
 * 不再各自重复定义 const API = process.env.REACT_APP_BACKEND_URL
 */

export const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
export const API = `${API_BASE}/api`;

/**
 * 把 axios 错误转成一句人能看懂的话。
 *
 * FastAPI 的 422 返回 detail 数组（每项含 loc/msg），直接显示原始 JSON
 * 对用户毫无意义，所以这里提取字段名和原因。
 */
export function apiErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  const detail = err?.response?.data?.detail;

  if (Array.isArray(detail) && detail.length) {
    const first = detail[0];
    const field = Array.isArray(first?.loc) ? first.loc.filter(p => p !== 'body').join(' → ') : '';
    const msg = first?.msg || 'invalid value';
    return field ? `${field}: ${msg}` : msg;
  }
  if (typeof detail === 'string' && detail) return detail;
  if (err?.response?.status) return `${fallback} (HTTP ${err.response.status})`;
  if (err?.message === 'Network Error') return 'Cannot reach the server. Check your connection.';
  return fallback;
}
